import { Component, OnInit, inject } from '@angular/core';
import { IClient } from '../../../model/common.model';
import { ClientStatusService } from '../../status/client-status.service';
import { MatDialog, MatDialogConfig, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../../../confirm-dialog/confirm-dialog.component';
import { SortService } from '../../../util/sort.service';
import { EcaGenericMessageDialogComponent, EcaGenericMessageDialogConfig } from '@drc-eca/eca-components-lib';
import { IService } from '../../../model/common.model';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { AddUpdateClientModalComponent } from '../add-update-client-modal/add-update-client-modal.component';
import { FormsModule, UntypedFormGroup } from '@angular/forms';
import { ViewClientServicesModalComponent } from '../view-client-services-modal/view-client-services-modal.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-update-client',
    standalone: true,
    templateUrl: './update-client.component.html',
    styleUrls: ['./update-client.component.scss'],
    imports: [MatTableModule, MatButtonModule, CommonModule, FormsModule, MatDialogModule],
    providers: [SortService],
})
export class UpdateClientComponent implements OnInit {
  private clientStatusSvc = inject(ClientStatusService);
  dialog = inject(MatDialog);

  clientList: any[] = [];
  client: IClient;
  selectedClient: IClient;
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  displayedColumns: string[] = ['code', 'title', 'description', 'services', 'action'];
  serviceList: IService[] = [];

  inprogress: boolean = false;

  dialogRef: MatDialogRef<ConfirmDialogComponent>;

  constructor() { }

  ngOnInit() {
    this.getClients();
    this.getServices();
  }

  getClients = () => {
    this.clientList = [];
    this.clientStatusSvc.doGet('admin/client').subscribe((data: IClient[]) => {
      this.clientList = this.clientStatusSvc.sortArray(data || [], 'code', 'asc');
      this.dataSource.data = this.clientList;
    }, (error: any) => {
      this.clientStatusSvc.showWarning(`Error while getting existing clients.`, error.message ? error.message : null);
    });
  }

  getServices = () => {
    this.serviceList = [];
    this.clientStatusSvc.doGet(`admin/service`).subscribe((data: IService[]) => {      
        this.serviceList = this.clientStatusSvc.sortArray(data || [], 'serviceName', 'asc');      
    }, () => {
      this.clientStatusSvc.showWarning('Error while getting existing services.');
    });
  }

  openAddUpdateClientModal(selectedClient: IClient = null){
    const serviceDialogRef = this.dialog.open(AddUpdateClientModalComponent, {
      data:{
        selectedClient: selectedClient,
        serviceList: this.serviceList
      },
      width: '90vw'
    });

    serviceDialogRef.afterClosed().subscribe((result: {cancel: boolean, form: UntypedFormGroup, serviceList: any[]}) => {
      let action = 'Add';
      if(!result.cancel){
        let payload = {};
        if(selectedClient){
          payload = selectedClient;
          action = 'Update';
        }
        payload['code'] = `${result.form.controls['code'].value}`.trim().toUpperCase();
        payload['title'] = result.form.controls['title'].value;
        payload['description'] = result.form.controls['description'].value;
        payload['services'] = {};
        (result.serviceList || []).filter(sl=>sl.checked).forEach(svc=>{
          console.log(svc)
          payload['services'][svc.primaryKeyPart] = svc.alias || svc.name;
        })
        this.addClient(payload, action);
      }
    });
  }

  addClient(payload: any, action: string) {
    this.inprogress = true;    
    this.clientStatusSvc.doPost(`admin/client`, payload).subscribe(() => {
      this.clientStatusSvc.showSuccess(`Client ${payload.code} ${action}ed successfully.`);
      this.inprogress = false;
      this.getClients();
    }, () => {
      this.inprogress = false;
      this.clientStatusSvc.showWarning(`Failed to ${action} client ${payload.code}.`);
    });
  }

  viewServices(selectedClient: any){
    const viewDialog = this.dialog.open(ViewClientServicesModalComponent, {
      data: {
        selectedClient: selectedClient,
        serviceList:  this.serviceList
      }
    });
    viewDialog.afterClosed().subscribe(()=>{});
  }

  openConfirmationDialog(client: IClient) {
    const dialogConfig: MatDialogConfig<EcaGenericMessageDialogConfig> = {
      data: {
        title: `Delete Client ${client.code}`,
        message: `Are you sure you want to delete "${client.code}" client?`,
        buttons: {
          negative: { label: 'Cancel' },
          positive: { label: 'Delete' }
        }
      },
      maxWidth: '650px'
    };

    const dialogRef = this.dialog.open(EcaGenericMessageDialogComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.deleteClient(client);
      }
    });
  }

  deleteClient(client: IClient) {
    this.inprogress = true;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    this.clientStatusSvc.doDelete('admin/client', client.code).subscribe(data => {
      this.clientStatusSvc.showSuccess(`Client ${client.code} deleted successfully.`);
      this.inprogress = false;
      this.getClients();
    }, () => {
      this.inprogress = false;
      this.clientStatusSvc.showWarning(`Failed to Delete client ${client.code}.`);
    });
  }

}
